export class RegistrationUser {
    firstName: string;
    mobileNumber: string;
    emailId: string;
}
